import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { ApiRequestError } from "@/lib/api";
import { queries } from "@/lib/queries";

/** Tudo em /app exige sessão. Sem sessão, vai para /entrar e volta depois. */
export const Route = createFileRoute("/app")({
  beforeLoad: async ({ context, location }) => {
    try {
      const me = await context.queryClient.query({ ...queries.me(), staleTime: 60_000 });
      return { me };
    } catch (err) {
      if (err instanceof ApiRequestError && err.status === 401) {
        throw redirect({ to: "/entrar", search: { redirecionar: location.href } });
      }
      throw err;
    }
  },
  component: () => <Outlet />,
});
